import { gql } from 'apollo-boost'

export const GET_USER_SALE_CONTRACTS = gql`
  query listUserSaleContracts {
    listUserSaleContracts {
      id
      construction {
        siengeCompanyId
        id
        name
        address
        constructionLogo {
          url
        }
        dashboardMedia {
          url
          id
        }
        miniatureUrl
      }
      constructionUnit {
        id
        name
        note
      }
      receivableBillId
    }
  }
`
